import { IFaqCard } from "../interfaces/faq-card.interface";
import { IRightColumnData } from "../interfaces/right-column-data.interface";
import { IEstatusCard } from "../interfaces/status-card.interface";
import { ROUTING_ESTADO_TRAMITE_PENSION } from "./url.constant";

export enum TramitePensionFlowsEnum {
  INICIAR_TRAMITE = "INICIAR_TRAMITE",
  VIDEO_ATENCION = "VIDEO_ATENCION",
  RETOMAR_TRAMITE = "RETOMAR_TRAMITE",
  TRAMITE_FINALIZADO = "TRAMITE_FINALIZADO",
}

export const TRAMITE_PENSION_ERROR_GENERAL_INICIO_MAX_REINTENTOS = 3;
export const SESSION_TRAMITE_PENSION_ERROR_GENERAL_INICIO_REINTENTOS_RESTANTES =
  "tp-error-general-inicio-reintentos-restantes";

export const HeadersTableBalances = [
  "Tipo de Cuenta",
  "Fondo",
  "Saldo Cuotas",
  "Saldo Pesos*",
];
export const HeadersTableBeneficiaries = ["Nombre", "Parentesco", "RUT"];

export const RUTAS_TRACKING = [ROUTING_ESTADO_TRAMITE_PENSION.INICIO,
ROUTING_ESTADO_TRAMITE_PENSION.CERTIFICADOS_SALDOS,
ROUTING_ESTADO_TRAMITE_PENSION.CERTIFICADOS_OFERTAS,
ROUTING_ESTADO_TRAMITE_PENSION.MODALIDAD_PENSION,
ROUTING_ESTADO_TRAMITE_PENSION.PAGO_PENSION
];

export const LabelStatus = {
  INICIAR_TRAMITE: {
    estadoTramite: "Sin iniciar",
    duracion: "20 minutos",
    plazoRevision: "Hasta 10 días hábiles"
  },
  TRAMITE_EN_CURSO: {
    estadoTramite: "En curso",
    duracion: "",
    plazoRevision: "Hasta 10 días hábiles"
  },
  TRAMITE_FINALIZADO: {
    estadoTramite: "Presentado",
    duracion: "",
    plazoRevision: "Hasta 10 días hábiles"
  },
};

export const MESSAGE = {
  ERROR_500: {
    title: "Lo sentimos, en este momento no podemos atender la solicitud.",
    subtitle: "El servicio no se encuentra disponible. Por favor, vuelve a intentarlo más tarde.",
    message:
      "Actualmente tenemos un problema con nuestros servicios, podrás intentarlo nuevamente más tarde.",
    textButton: "Aceptar",
    eventClickButton: "goToHome",
    backButton: false
  },

  ERROR_404: {
    title: "Lo sentimos, no encontramos está página",
    subtitle: "El servicio no se encuentra disponible. Por favor, vuelve a intentarlo más tarde.",
    message:
      "Actualmente tenemos un problema con nuestros servicios, podrás intentarlo nuevamente más tarde.",
    textButton: "Aceptar",
    eventClickButton: "goToHome",
    backButton: false
  },

  ERROR_GENERAL_INICIAR_TRAMITE: {
    useGeneralErrorLayout: true,
    title: "En este momento no podemos atender tu solicitud",
    subtitle:
      "Lo sentimos, el servicio no se encuentra disponible. Por favor, vuelve a intentarlo.",
    infoBoxHtml:
      '<p><strong>Para más información</strong></p><p>Llámanos al <a href="tel:+566006600900">600 6600 900</a>, escríbenos al WhatsApp <a href="https://wa.me/56936391222" target="_blank" rel="noopener noreferrer">+569 3639 1222</a> o agenda una <a href="/video-atencion">Video Atención</a>.</p>',
    textButton: "Reintentar",
    eventClickButton: "goToTramitePensionInicio",
    primaryButtonIcon: "refresh-outline",
    textButton2: "Ir a Inicio",
    eventClickButton2: "goToAppHome",
    backButton: false,
  },

  ERROR_SESION: {
    title: "Tu sesión expiró, para continuar vuelve a iniciar sesión",
    subtitle: "Por motivos de seguridad cerramos tu sesión luego de 20 minutos de inactividad.",
    message: "Iniciar sesión nuevamente y retoma tu trámite.",
  },

  ERROR_NO_CUMPLE_REQUISITOS: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Esta solicitud es para trabajadores del sector privado y <b>no considera casos de beneficiarios con algún tipo de invalidez o empleados del sector público</b>.<br>Es probable que este sea tu caso o que debas actualizar tu información personal.",
    message: "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
  },
  ERROR_NO_CUMPLE_REQUISITOS_EXTRANJERO: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Esta solicitud es para trabajadores del sector privado y <b>no considera casos de beneficiarios con algún tipo de invalidez o empleados del sector público</b>.<br>Es probable que este sea tu caso o que debas actualizar tu información personal.",
    message: "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
  },

  ERROR_INGRESO_SERVICIOS_TRAMITE_PENSION: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle: 'Puedes intentarlo más tarde o ingresar tu trámite de pensión a través de estas dos alternativas:<br> <br> <ol>  <li>Agenda una Video Atención con uno de nuestros ejecutivos.</li> <li>Accede a nuestra asistente virtual Clara y en el menú selecciona "Video Atención", en donde un ejecutivo te atenderá de forma inmediata.</li>   </ol>',
    message: "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    textButton2: "Preguntar a Clara",
    eventClickButton2: "goToClara",
  },

  ERROR_NO_CUMPLE_CON_ESTADO_CIVIL_VALIDACION: {
    title: "No cumples con los requisitos para realizar la solicitud de pensión",
    subtitle: "Según nuestros registros, tu <b>estado civil</b> no te permite avanzar con esta solicitud",
    message: "Para presentar tu solicitud de pensión, te sugerimos agendar una Video Atención para que un ejecutivo valide tu estado civil.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    textButton2: "Preguntar a Clara",
    eventClickButton2: "goToClara",
  },

  ERROR_BENEFICIARIO_CON_INVALIDEZ: {
    title: "Tu solicitud de pensión necesita la atención de un ejecutivo",
    subtitle: "El trámite en línea no contempla beneficiarios con algún tipo de invalidez o beneficiarios extranjeros.",
    tituloLista: "¿Por qué no se consideran estos casos?",
    lista: ["Porque requieren un análisis especial de nuestros ejecutivos, para asegurar que no pierdas ningún beneficio legal."],
    message: "Te sugerimos agendar una Video Atención para iniciar tu trámite.",
    textButton2: "Agendar Video Atención",
    eventClickButton2: "goToVideoAtencion",
  },

  ERROR_NO_AHORROS_OBLIGATORIOS_AFP_CAPITAL: {
    title: "No cumples los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Según nuestros registros, <b>no cuentas con ahorros obligatorios en nuestra AFP.</b>",
    message:
      "Si deseas traer tus ahorros obligatorios a AFP Capital, te sugerimos realizar tu cambio o agendar una Video Atención.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    textButton2: "Cámbiate a AFP Capital",
    eventClickButton2: "goToCambiateAfpCapital",
    validacionInicial: true,
  },

  ERROR_SIN_SALDOS_OBLIGATORIOS_AFP_CAPITAL: {
    title: "No cumples los requisitos para realizar la solicitud de pensión",
    subtitle:
      "Según nuestros registros, <b>no cuentas con ahorros suficientes iniciar el trámite.</b>",
    message:
      "Hay alternativas del Estado pensadas para ti. Agenda una Video Atención y un ejecutivo te explicará cuáles son y cómo acceder a ellas. ",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    validacionInicial: true,
  },

  ERROR_LPA_SALDO_RETENIDO: {
    title: "No podemos ingresar tu solicitud de pensión",
    subtitle:
      "Según nuestros registros, tu saldo esta retenido por una resolución judicial notificada de acuerdo a la Ley Nº 21.484. Podrás realizar el trámite una vez se regularice la situación.",
    message:
      "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    textButton2: "Preguntar a Clara",
    eventClickButton2: "goToClara",
  },

  ERROR_APVC_SALDO: {
    title: "No podemos ingresar tu solicitud de pensión",
    subtitle:
      "Según nuestros registros, tienes una cuenta de <b>Ahorro Previsional Voluntario Colectivo - APVC</b> que no permite avanzar con la solicitud en línea.",
    message:
      "Te aconsejamos agendar una Video Atención en donde uno de nuestros ejecutivos puede orientarte.",
    textButton: "Agendar Video Atención",
    eventClickButton: "goToVideoAtencion",
    useAlertIcon: true,
  },

  ERROR_BENEFICIARIOS_VALIDACION_AGRUPADA: {
    title: "Tus beneficiarios necesitan una revisión",
    tituloLista: "¿Por qué no puedes continuar con la solicitud?",
    lista: [], // Se llena dinámicamente según los errores encontrados
    message: "Es necesario que edites tus beneficiarios o elimines a los que no cumplen con los requisitos.",
    textButton: "Editar beneficiarios",
    eventClickButton: "goToBeneficiario",
    textButton2: "Agendar Video Atención",
    eventClickButton2: "goToVideoAtencion",
  },
};

export const STORAGE_PREGUNTAS_RESPUESTAS_MODAL_PENSION_HISTORY = 'preguntasRespuestasModalPensionHistory';
export const STORAGE_PREGUNTAS_ANTECEDENTES_PENSION = 'antecedentesPension';
export const STORAGE_FORMULARIO_DATOS_PERSONALES = 'formularioDatosPesonales';
export const PENSION_PROCESS_RESPONSE = 'pension_process_response';
export const STORAGE_MODAL_BENEFICIOS_REFORMA_TRAMITE_PENSION_RESPONSE = 'modalBeneficiosReformaTramitePensionResponse';
export const TP_PERSONAL_DATA = 'tp_personal_data';
export const TP_BENEFICIARIES = 'tp_beneficiaries';
export const TP_MODAL_ACTIVO = 'tp_modal_activado';

export const CODIGO_VALIDACIONES_EXITOSA = 'AU00';
export const CODIGOS_VALIDACIONES_TRAMITE_EN_CURSO = ['AU04'];
export const CODIGOS_VALIDACIONES_TRAMITE_PRESENTADO = ['AU05', 'AU155'];
export const CODIGOS_VALIDACIONES_TRAMITE_EN_PROCESO = [...CODIGOS_VALIDACIONES_TRAMITE_EN_CURSO, ...CODIGOS_VALIDACIONES_TRAMITE_PRESENTADO];

export const CODIGO_INSTITUCION_SALUD_DESCONOCIDO = 999;
export const TRAMITE_PENSION_SIN_MANDATARIO = "N";
export const CONDICION_LABORAL_EMPLEADOR = "E";
export const CONDICION_LABORAL_DESEMPLEADO = "D";

export const CODIGO_PARENTESTO_CONYUGE_SIN_HIJOS_CON_DERECHO = 10;
export const CODIGO_PARENTESTO_CONYUGE_CON_HIJOS_CON_DERECHO = 11;
export const CODIGO_PARENTESTO_CONYUGE_SIN_PENSION = 16;
export const CODIGO_PARENTESTO_CONVCIVIL_SIN_HIJOS_CON_DERECHO = 22;
export const CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_COMUN_CON_DERECHO = 23;
export const CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_CON_DERECHO = 24;
export const CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_CAUSANTE_CON_DERECHO = 25;
export const CODIGO_PARENTESTO_HIJO_O_HIJA = 30;
export const CODIGO_PARENTESTO_HIJO_CON_INVALIDEZ = 31;

// Edad máxima para hijo beneficiario
export const EDAD_MAXIMA_HIJO_BENEFICIARIO = 24;

// Códigos de parentesco que indican "con hijos"
export const CODIGOS_PARENTESCO_CON_HIJOS = [
  CODIGO_PARENTESTO_CONYUGE_CON_HIJOS_CON_DERECHO,
  CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_COMUN_CON_DERECHO,
  CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_CAUSANTE_CON_DERECHO
];

// Códigos de parentesco válidos para cónyuge según estado civil
export const CODIGOS_CONYUGE: readonly number[] = [
  CODIGO_PARENTESTO_CONYUGE_SIN_HIJOS_CON_DERECHO,
  CODIGO_PARENTESTO_CONYUGE_CON_HIJOS_CON_DERECHO,
  CODIGO_PARENTESTO_CONYUGE_SIN_PENSION
];

// Códigos de parentesco válidos para conviviente civil según estado civil
export const CODIGOS_CONVIVIENTE_CIVIL: readonly number[] = [
  CODIGO_PARENTESTO_CONVCIVIL_SIN_HIJOS_CON_DERECHO,
  CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_COMUN_CON_DERECHO,
  CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_CON_DERECHO,
  CODIGO_PARENTESTO_CONVCIVIL_CON_HIJOS_CAUSANTE_CON_DERECHO
];

export const PARENTESCOS_PERMITIDOS = [1, 10, 11, 16, 22, 23, 24, 25, 30];
export enum TipoErrorValidacionBeneficiarios {
  PARENTESCO_NO_PERMITIDO = "PARENTESCO_NO_PERMITIDO",
  ESTADO_CIVIL_SIN_BENEFICIARIO = "ESTADO_CIVIL_SIN_BENEFICIARIO",
  ERROR_SERVICIO = "ERROR_SERVICIO",
  BENEFICIARIO_CON_INVALIDEZ = "BENEFICIARIO_CON_INVALIDEZ",
  BENEFICIARIO_CON_HIJOS_SIN_HIJO_EN_LISTA = "BENEFICIARIO_CON_HIJOS_SIN_HIJO_EN_LISTA",
  HIJO_NO_MENOR_24_SOLTERO = "HIJO_NO_MENOR_24_SOLTERO",
  CONYUGE_SIN_HIJOS_TIENE_HIJO_COMUN = "CONYUGE_SIN_HIJOS_TIENE_HIJO_COMUN",
  HIJO_SOLO_CAUSANTE_CON_PARENTESCO_INCORRECTO = "HIJO_SOLO_CAUSANTE_CON_PARENTESCO_INCORRECTO",
  HIJO_SIN_APELLIDO_CAUSANTE = "HIJO_SIN_APELLIDO_CAUSANTE",
}

/**
 * Mensajes de lista para cada tipo de error de validación de beneficiarios
 * El orden en el array define el orden de visualización en pantalla
 */
export const MENSAJES_LISTA_ERRORES_BENEFICIARIOS = [
  {
    tipo: TipoErrorValidacionBeneficiarios.ESTADO_CIVIL_SIN_BENEFICIARIO,
    mensaje: "Declaraste estar <b>casado o ser conviviente civil</b>. Agrega a tu cónyuge en la lista de beneficiarios."
  },
  {
    tipo: TipoErrorValidacionBeneficiarios.BENEFICIARIO_CON_HIJOS_SIN_HIJO_EN_LISTA,
    mensaje: "Declaraste estar <b>casado o ser conviviente civil con hijos</b>. Agrega estos últimos como beneficiarios para iniciar tu solicitud."
  },
  {
    tipo: TipoErrorValidacionBeneficiarios.HIJO_NO_MENOR_24_SOLTERO,
    mensaje: "Uno o más beneficiarios hijos no cumplen con los requisitos para iniciar la solicitud: Los beneficiarios hijos <b>deben ser solteros y menores de 24 años</b>."
  },
  {
    tipo: TipoErrorValidacionBeneficiarios.PARENTESCO_NO_PERMITIDO,
    mensaje: "Este trámite no considera como beneficiarios a: Padre, Madre, Tutor, Abuelos, Nietos o Sobrinos."
  },
  {
    tipo: TipoErrorValidacionBeneficiarios.CONYUGE_SIN_HIJOS_TIENE_HIJO_COMUN,
    mensaje: "Indicaste estar <strong>casado o ser conviviente civil sin hijos en común. Sin embargo, en nuestros registros aparecen hijos en común.</strong>"
  },
  {
    tipo: TipoErrorValidacionBeneficiarios.HIJO_SIN_APELLIDO_CAUSANTE,
    mensaje: "Indicaste estar <strong>casado o ser conviviente civil con hijos en común. Sin embargo, el apellido no coinciden con el tuyo.</strong>"
  },
  {
    tipo: TipoErrorValidacionBeneficiarios.HIJO_SOLO_CAUSANTE_CON_PARENTESCO_INCORRECTO,
    mensaje: "Indicaste estar <strong>casado o ser conviviente civil con hijos en común. Sin embargo, en nuestros registros no aparecen hijos en común.</strong>"
  }

];

export const FEMALE_LEGAL_AGE = 60;
export const MALE_LEGAL_AGE = 65;
export const FEMALE = 'FEMENINO';
export const MALE = 'MASCULINO';
export const EDAD_MINIMA_PREGUNTAS_PGU = 65;

export const LEGAL_AGE = {
  [FEMALE]: FEMALE_LEGAL_AGE,
  [MALE]: MALE_LEGAL_AGE
}

export const TIPO_RECEPTOR_AFILIADO = "A";

export const CODIGO_INSITUCION_FINANCIERA_EMISOR_PAGO_SANTANDER = 37;
export const STORAGE_FORM_VIA_PAGO = 'form_via_pago';
export const STORAGE_TIPO_TRAMITE = 'tipo_tramite_pension';

export const TIPO_TRAMITE_FLUJO = {
  VEJEZ_NORMAL: {
    tipo: "VN",
    descripcion: "Pensión por Vejez",
  },
  VEJEZ_ANTICIPADA: {
    tipo: "VA",
    descripcion: "Pensión por Vejez Anticipada",
  }
};

export const TIPO_TRAMITE = [
  { id: 'CONTRIBUCION DE INVALIDEZ', name: "Contribución de invalidez" },
  { id: 'APORTE ADICIONAL', name: "Aumento de cotización a un 11%" },
  { id: 'CALIFICACION BENEFICIARIO', name: "Calificación beneficiario" },
  { id: 'ASIGNACION FAMILIAR', name: "Asignación Familiar" },
  { id: 'CUOTA MORTUORIA', name: "Cuota Mortuoria" },
  { id: 'EXCEDENTE LIBRE DISPOSICION', name: "Giro PEX" },
  { id: 'GARANTIA ESTATAL', name: "Garantía Estatal" },
  { id: 'HERENCIA', name: "Herencia" },
  { id: 'INVALIDEZ PRIMER DICTAMEN', name: "Pensión de Invalidez - Primer dictamen" },
  { id: 'INVALIDEZ', name: "Pensión de Invalidez" },
  { id: 'PENSION ADICIONAL BONO EXONERADO', name: "Pensión adicional - Bono exonerado" },
  { id: 'PENSION ADICIONAL ARTICULO 69', name: "Pensión adicional - Artículo 69" },
  { id: 'REEVALUACION O SEGUNDO DICTAMEN', name: "Pensión de Invalidez - Reevaluación o segundo dictamen" },
  { id: 'REEVALUACION INVALIDEZ', name: "Pensión de Invalidez - Reevaluación" },
  { id: 'RESCILIACION', name: "Resciliación" },
  { id: 'CAMBIO DE MODALIDAD', name: "Cambio de modalidad de pensión" },
  { id: 'SOBREVIVENCIA', name: "Pensión de Sobrevivencia" },
  { id: 'TRASPASO PRIMA', name: "Traspaso de prima" },
  { id: 'INVALIDEZ UNICO DICTAMEN', name: "Pensión de Invalidez - Único dictamen" },
  { id: 'VEJEZ ANTICIPADA', name: "Pensión por Vejez Anticipada" },
  { id: 'VEJEZ EDAD', name: "Pensión por Vejez" },
  { id: 'CIERRE TRAMITES DE PENSION', name: "Cierre de trámites de pensión" },
  { id: 'REITERACION DE PAGOS POR CHEQUE CADUCAD', name: "Reiteración de pagos por cheque caducado" },
  { id: 'PENSION ADICIONAL B. EXONERADO ADICIONAL', name: "Pensión adicional B - Exonerado adicional" },
  { id: 'INVALIDEZ PREVIA', name: "Pensión de Invalidez - Previa" },
];

export const BONOS_RECONOCIMIENTOS_LIQUIDADO = "08";
export const BONOS_RECONOCIMIENTOS_NORMAL = "27";
export const BONOS_RECONOCIMIENTOS_PAGO_PENDIENTE = "29";
export const ESTADO_CIVIL_CASADO = "CASADO";
export const ESTADO_CIVIL_CONVIVIENTE_CIVIL = "CONVIVIENTE CIVIL";

// Códigos de estado civil del servicio de beneficiarios
export const CODIGO_ESTADO_CIVIL_SOLTERO = "S";
export const CODIGO_ESTADO_CIVIL_CASADO = "C";
export const CODIGO_ESTADO_CIVIL_CONVIVIENTE_CIVIL = "K";
export const CODIGO_ESTADO_CIVIL_VIUDO = "V";
export const CODIGO_ESTADO_CIVIL_DIVORCIADO = "D";

export const VEJEZ_EDAD = "Vejez Edad";
export const VEJEZ_ANTICIPADA = "Vejez Anticipada";

export const RESPONSE_TRACKING = "response_tracking";

//  REFORMA PENSIONES
export const RESPONSE_BENEFICIOS_REFORMA_PENSIONES = "response_beneficios_reforma_pensiones";
export const RESPONSE_CALENDARIO_REFORMA_PENSIONES = "response_calendario_reforma_pensiones";
//  REFORMA PENSIONES


export const ESTATUS_CARD_DATA: IEstatusCard[] = [
  {
    title: 'Paso 1: Inicio trámite de pensión',
    statusText: 'Estado: En curso',
    statusClass: 'en-curso',
    infoBoxMessage: '',
    details: [],
    infoText: '',
    requestTitle: '',
    requestDescription: '',
    requestLink: '',
    requestLinkText: '',
    requestTitleImportant: '',
    requestDescriptionInfoImportant: '',
    infoImportant: '',
    infoImportantStrong: '',
  },
  {
    title: 'Paso 2: Certificado de Saldos',
    statusText: 'Estado: En curso',
    statusClass: 'en-curso',
    infoBoxMessage: '',
    details: [],
    infoText: 'En esta etapa podrás acceder al Certificado de Saldos, el cual muestra tus ahorros, beneficiarios y renta promedio. Con esto puedes solicitar ofertas de pensión.',
    requestTitle: '',
    requestDescription: '',
    requestLink: '/video-atencion',
    requestLinkText: 'Video Atención',
    requestTitleImportant: 'Importante',
    requestDescriptionInfoImportant: '',
    infoImportant: '',
    infoImportantStrong: '',
    infoImportantInnerHTML: 'Al descargar tu Certificado de Saldos <strong>debes comunicarte con uno de nuestros ejecutivos para solicitar la oferta de pensión</strong>, antes de la fecha de vencimiento del documento, <strong>de lo contrario, tu trámite se cerrará automáticamente.</strong><br><br> ¿Necesitas solicitar la oferta o hacer preguntas sobre la información del certificado? Comunícate con nosotros por una <a href="/video-atencion">Video Atención</a>, llamando al <a href="tel:+6006600900">600 6600 900</a>',
  },
  {
    title: 'Paso 3: Certificado de Ofertas SCOMP',
    statusText: 'Estado: En curso',
    statusClass: 'en-curso',
    infoBoxMessage: '',
    details: [],
    infoText: 'En esta etapa puedes conocer alternativas de montos y modalidades de pensión, ofrecidas por distintas AFP y Compañías de Seguros.',
    requestTitle: '',
    requestDescription: '',
    requestLink: '/video-atencion',
    requestLinkText: 'Video Atención',
    requestTitleImportant: 'Importante',
    requestDescriptionInfoImportant: 'Selecciona la modalidad de pensión, mediante una',
    infoImportant: '',
    infoImportantStrong: 'deberás elegir una modalidad, de lo contrario no podrás continuar con el trámite.'
  },
  {
    title: 'Paso 4: Modalidad de pensión',
    statusText: 'Estado: En curso',
    statusClass: 'en-curso',
    infoBoxMessage: '',
    details: [],
    infoText: 'Te avisaremos cuando el trámite finalice y puedas recibir el pago de tu pensión.',
    requestTitle: '',
    requestDescription: '',
    requestLink: '',
    requestLinkText: '',
    requestTitleImportant: '',
    requestDescriptionInfoImportant: '',
    infoImportant: '',
    infoImportantStrong: ''
  },
  {
    title: 'Paso 5: Pago de pensión',
    statusText: 'Estado: Completado',
    statusClass: 'completado',
    infoBoxMessage: '',
    details: [],
    infoText: '',
    requestTitle: '',
    requestDescription: '',
    requestLink: '',
    requestLinkText: '',
    requestTitleImportant: 'Importante',
    requestDescriptionInfoImportant: '',
    infoImportant: 'Si quieres continuar trabajando pero dejar de cotizar, te sugerimos acercarte a nuestras sucursales para comenzar con el trámite.',
    infoImportantStrong: ''
  },
];

export const GLOSA_MODALIDAD_PENSION = {
  RETIRO_PROGRAMADO: "Retiro Programado",
  RENTA_VITALICIA_INMEDIATA: "Renta Vitalicia Inmediata",
  RENTA_VITALICIA_DIFERIDA: "Renta Vitalicia Diferida",
  RENTA_TEMPORAL_CON_RENTA_VITALICIA_DIFERIDA: "Renta temporal con Renta Vitalicia Diferida",
  RENTA_VITALICIA_INMEDIATA_CON_RETIRO_PROGRAMADO: "Renta Vitalicia Inmediata con Retiro Programado",
} as const;

export const CODIGO_MODALIDAD_PENSION = {
  RPS: "RPS",
  RPN: "RPN",
  RVRP: "RVRP",
  RVI: "RVI",
  RVD: "RVD",
} as const;

export const MODALIDADES_PENSION: Readonly<
  Record<string, { glosa: string } | undefined>
> = {
  [CODIGO_MODALIDAD_PENSION.RPS]: {
    glosa: GLOSA_MODALIDAD_PENSION.RETIRO_PROGRAMADO,
  },
  [CODIGO_MODALIDAD_PENSION.RPN]: {
    glosa: GLOSA_MODALIDAD_PENSION.RETIRO_PROGRAMADO,
  },
  [CODIGO_MODALIDAD_PENSION.RVRP]: {
    glosa: GLOSA_MODALIDAD_PENSION.RENTA_VITALICIA_INMEDIATA_CON_RETIRO_PROGRAMADO,
  },
  [CODIGO_MODALIDAD_PENSION.RVI]: {
    glosa: GLOSA_MODALIDAD_PENSION.RENTA_VITALICIA_INMEDIATA,
  },
  [CODIGO_MODALIDAD_PENSION.RVD]: {
    glosa: GLOSA_MODALIDAD_PENSION.RENTA_VITALICIA_DIFERIDA,
  },
} as const;

export const FAQ_CARD: IFaqCard[] = [
  {
    step: 1,
    questions: [
      {
        title: 'Revisa la pregunta frecuente',
        subtitle: '',
        items: [
          {
            question: '¿Qué ocurre en esta etapa?',
            answer1: 'Se revisa el cumplimiento de los requisitos y antecedentes para el trámite, incluye documentos presentados, las cuentas y saldos que se utilizarán para la pensión. Estas validaciones permiten continuar con la solicitud de pensión.',
            isOpen: false,
          },
        ],
      },
    ],
  },
  {
    step: 2,
    questions: [
      {
        title: 'Revisa las preguntas frecuentes',
        subtitle: '',
        items: [
          {
            question: '¿Qué es el Certificado de Saldos?',
            answer1: 'Es un documento emitido por la AFP, que muestra lo que tienes ahorrado en pesos, UF y en cuotas, en tu cuenta obligatoria y cualquier otro ahorro voluntario que tengas destinado a tu pensión.',
            isOpen: false,
          },
          {
            question: '¿Qué ocurre en esta etapa?',
            answer1: 'Se disponibiliza el Certificado de Saldos, donde puedes revisar lo que has aportado al sistema de pensiones, tanto en la cuenta obligatoria como en ahorros voluntarios, si fueron destinados a la pensión.',
            isOpen: false,
          },
          {
            question: '¿Cuáles son los tiempos a considerar si solicitaste tu Bono de Reconocimiento junto con el inicio del trámite?',
            answer1: 'Una vez solicitado el Bono de Reconocimiento, como AFP tenemos 5 días hábiles para enviar tu solicitud a la ex-caja previsional. Luego de 10 días, la entidad del antiguo sistema enviará la respuesta con la aceptación preliminar o el rechazo. Si la respuesta es positiva, el Bono se emitirá en 45 días corridos o en un plazo promedio de 160 días hábiles para Capredena y Dipreca. Una vez emitido el bono y cumplido el plazo para el cobro, la AFP debe solicitar su liquidación y la institución tiene plazo de 60 días para liquidarlo. Luego de esto formará parte de los ahorros y se informará en el Certificado de Saldos.',
            isOpen: false,
          },
          {
            question: '¿Cuáles son los siguientes pasos?',
            answer1: 'Te avisaremos cuando tu Certificado de Saldos esté listo. Recuerda que puedes descargarlo aquí mismo en la web o solicitarlo mediante una Video Atención o en sucursales.',
            isOpen: false,
          },
        ],
      },
    ],
  },
  {
    step: 3,
    questions: [
      {
        title: 'Conoce las modalidades de pensión',
        subtitle: 'Para que tomes una decisión de manera informada, te recomendamos revisar las distintas modalidades:',
        items: [
          {
            question: GLOSA_MODALIDAD_PENSION.RETIRO_PROGRAMADO,
            codigosTipoModalidad: [CODIGO_MODALIDAD_PENSION.RPS, CODIGO_MODALIDAD_PENSION.RPN],
            answer1: 'La persona pensionada mantiene sus fondos en la AFP y la pensión se obtiene mensualmente del saldo de la Cuenta de Capitalización Individual.',
            answer2: 'Si el pensionado fallece y no hay beneficiarios, el saldo que exista en la cuenta se transforma en herencia.',
            isOpen: false,
          },
          {
            question: GLOSA_MODALIDAD_PENSION.RENTA_VITALICIA_INMEDIATA,
            codigosTipoModalidad: [CODIGO_MODALIDAD_PENSION.RVI],
            answer1: 'En este caso, la persona pensionada contrata una Compañía de Seguros de Vida, la cual pagará pensión de forma mensual y fija durante toda su vida, y en caso de fallecimiento, a sus beneficiarios de pensión.<br>El afiliado puede optar por esta modalidad sólo si su pensión es mayor o igual a 2 UF.',
            isOpen: false,
          },
          {
            question: GLOSA_MODALIDAD_PENSION.RENTA_VITALICIA_DIFERIDA,
            codigosTipoModalidad: [CODIGO_MODALIDAD_PENSION.RVD],
            answer1: 'Se combina el Retiro Programado con la Renta Vitalicia. En este caso, a contar de una fecha posterior al momento en que se pensiona, la persona contrata el pago de una renta mensual fija reajustable en UF en una Compañía de Seguros de Vida.',
            answer2: 'El pensionado recibe mensualmente una pensión pagada por la AFP, entre la fecha en que solicita esta modalidad y la fecha en que comienza a percibir la renta vitalicia.',
            isOpen: false,
          },
          {
            question: GLOSA_MODALIDAD_PENSION.RENTA_TEMPORAL_CON_RENTA_VITALICIA_DIFERIDA,
            codigosTipoModalidad: [CODIGO_MODALIDAD_PENSION.RVD],
            answer1: 'Se dividen los fondos, una parte se entrega a la AFP y otra a la Compañía de Seguros. Al comienzo, la AFP paga la pensión y luego la Compañía de Seguros.',
            answer2: 'En caso de fallecimiento, si quedan fondos en la AFP pueden quedar de herencia y Pensión de Sobrevivencia. En el caso de la Compañía de Seguros solo generan Pensión de Sobrevivencia.',
            isOpen: false,
          },
          {
            question: GLOSA_MODALIDAD_PENSION.RENTA_VITALICIA_INMEDIATA_CON_RETIRO_PROGRAMADO,
            codigosTipoModalidad: [CODIGO_MODALIDAD_PENSION.RVRP],
            answer1: 'Un porcentaje de los fondos se quedan en la AFP como Retiro Programado y el otro se convierte en Renta Vitalicia en una Compañía de Seguros. Son dos pagos que se realizan de forma paralela.',
            answer2: 'En caso de fallecimiento, los fondos que se encuentren en la AFP se vuelven herencia o Pensión de Sobrevivencia, mientras los que queden en la Compañía de Seguros solo pueden ser Pensión de Sobrevivencia.',
            isOpen: false,
          },
        ],
      },
      {
        title: 'Revisa las preguntas frecuentes',
        subtitle: '',
        items: [
          {
            question: '¿Qué es el Certificado de Ofertas SCOMP?',
            answer1: 'En este documento podrás conocer alternativas para tu pensión. Se detallan las diferentes modalidades, plazos y entidades encargadas de los pagos.',
            isOpen: false,
          },
          {
            question: '¿Para qué sirve el Certificado de Ofertas SCOMP?',
            answer1: 'Con este documento podrás conocer tus alternativas y así seleccionar la opción que más se acomode a tus necesidades. Si no estás conforme, puedes solicitarlo máximo 3 veces, mientras dure la vigencia del Certificado de Saldos.',
            isOpen: false,
          },
          {
            question: '¿Cuál es la duración del Certificado de Ofertas SCOMP?',
            answer1: 'Su vigencia es de 12 días hábiles desde su emisión.',
            isOpen: false,
          },
          {
            question: '¿Cuáles son los siguientes pasos?',
            answer1: 'El siguiente paso es elegir una modalidad de pensión, para esto puedes contactarnos a través de Video Atención o directamente en nuestras sucursales. En el caso de optar por Retiro Programado, continuarás con nosotros y cursaremos el primer pago.',
            isOpen: false,
          },
        ],
      },
    ],
  },
  {
    step: 4,
    questions: [
      {
        title: 'Tu modalidad de pensión',
        items: [],
      },
    ],
  },
];

export const RIGHT_COLUMN_DATA: IRightColumnData[] = [
  {
    sectionTitle: 'Revisa',
    sections: [
      {
        title: 'Paso 1 - Inicio trámite de pensión',
        element: 'statusElement',
        active: true,
      },
      {
        title: 'Revisa las preguntas frecuentes',
        element: 'faqElement',
      },
    ],
  },
  {
    sectionTitle: 'Revisa',
    sections: [
      {
        title: 'Paso 2: Certificado de Saldo',
        element: 'statusElement',
        active: true,
      },
      {
        title: 'Revisa las preguntas frecuentes',
        element: 'faqElement',
      },
    ],
  },
  {
    sectionTitle: 'Revisa',
    sections: [
      {
        title: 'Paso 3: Certificado de Ofertas',
        element: 'statusElement',
        active: true,
      },
      {
        title: 'Conoce las modalidades de pensión',
        element: 'faqModalElement',
      },
      {
        title: 'Revisa las preguntas frecuentes',
        element: 'faqElement',
      },
    ],
  },
  {
    sectionTitle: 'Revisa',
    sections: [
      {
        title: 'Paso 4: Modalidad de pensión',
        element: 'statusElement',
        active: true,
      },
      {
        title: 'Tu modalidad de pensión',
        element: 'faqElement',
      },
    ],
  },
  {
    sectionTitle: 'Revisa',
    sections: [
      {
        title: 'Paso 5: Pago de pensión',
        element: 'statusElement',
        active: true,
      },
    ],
  },
];

export const ESTATUS_INFO_TEXT = {
  [VEJEZ_EDAD]: 'En esta etapa, ya ingresaste tu solicitud de trámite de Pensión por Vejez normal. Es el derecho que tienen las personas afiliadas al sistema de pensiones, una vez hayan cumplido la edad legal de 60 años para las mujeres y 65 años los hombres.',
  [VEJEZ_ANTICIPADA]: 'En esta etapa, ya ingresaste tu solicitud de trámite de Pensión por Vejez Anticipada. Es el derecho para acogerse a una pensión antes de cumplir la edad legal, es decir, los 65 años en el caso de los hombres, y antes de los 60 años en el caso de las mujeres.',
};

export const DIAS_VIGENCIA_CERTIFICADO_SALDOS = 35;
export const DIAS_VIGENCIA_CERTIFICADO_OFERTAS = 12;

export const PREGUNTAS_ANTECEDENTE_PREVISIONAL = [
  { id: 1, descripcion: "Pago preliminar" },
  { id: 2, descripcion: "Pensión de manera retroactiva" },
  { id: 3, descripcion: "Ajuste de pensión a 2UF. En caso de el monto resulte inferior a éste." },
  { id: 4, descripcion: "Solicitud de cálculo del Excedente de Libre Disposición" },
  { id: 5, descripcion: "Solicitud de Pensión Garantizada Universal - PGU" },
  { id: 6, descripcion: "Publicación de datos personales aparezcan en un listado público" },
  { id: 7, descripcion: "Solicitud Congelamiento de saldos" },
];
